<template>
  <el-dialog
    width="35%"
    title="Saved Profile Filters"
    :visible.sync="dialogVisible"
    @close="handleClose"
  >
    <el-table id="optin-table" v-loading="loading" :data="queries">
      <el-table-column prop="title" width="250" label="Title" />
      <el-table-column type="insertedAt" width="180" label="Date Created">
        <template slot-scope="scope">
          <span>{{ scope.row.inserted_at | moment('lll') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Actions" width="180">
        <template slot-scope="scope">
          <el-popconfirm
            confirm-button-text="Yes, I'm sure"
            cancel-button-text="Cancel"
            icon="el-icon-info"
            icon-color="red"
            title="Are you want to apply this filter?"
            @onConfirm="handleApply(scope.row)"
          >
            <el-button slot="reference" size="mini">Apply</el-button>
          </el-popconfirm>

          <el-popconfirm
            confirm-button-text="Yes, Delete"
            cancel-button-text="Cancel"
            icon="el-icon-info"
            icon-color="red"
            title="Are you sure to delete this filter?"
            @onConfirm="handleDelete(scope.row)"
          >
            <el-button slot="reference" type="danger" size="mini">Delete</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  name: 'SavedFilterList',
  data: () => ({
    dialogVisible: false,
  }),
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    queries: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleApply(savedQuery) {
      this.$emit('apply-query', savedQuery.filter);
    },
    handleDelete(savedQuery) {
      this.$emit('delete-query', savedQuery.id);
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
};
</script>

<style scoped>
#optin-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// SavedQueryList.vue?6f40894a